module.exports = __webpack_public_path__ + "static/media/google-play-store.ec9a3944.png";